export class ChoosePlanProduct {
    
	planName: string;
	limitVisits: number;
	limitDistance: number;
	limitTime: number;
	unitDistance: string;
	unitTime: string;
	productId: number;
	coverageCategoryId: number;
	priceName: string;
	itemPrice = 0;
	unityPrice: string;
	coverageDescription: string;
	offerMonths: number;
	productPolicyKey: number;
	pricebookKey: number;
	productDetails: string;
	editing = false;
	originalValue: number;
	suggestedValue: number;
	priceFormatted: string;
	policyDescription: string;
	isSaving = false;

  	constructor() {	

	}
}
